import { Injectable } from "@angular/core";
import { BehaviorSubject, fromEvent, merge, Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class ConnectivityService {
    isUserOnline = new BehaviorSubject<boolean>(navigator.onLine);
    isUserDeviceOnline$: Observable<boolean> = this.isUserOnline.asObservable();

    constructor() {
        merge(
            fromEvent(window, "online").pipe(map(() => true)),
            fromEvent(window, "offline").pipe(map(() => false)),
        ).subscribe((status) => {
            this.isUserOnline.next(status);
        });
    }
}
